

















import {
  computed,
  defineComponent,
  Ref,
  ref,
  toRefs,
  watch
} from '@nuxtjs/composition-api'
import CGoogleAutocompleteInput from '~/components/shared/configurable/form/autocomplete/CGoogleAutocompleteInput.vue'
import { formFieldProps } from '~/constants/form'
import CGoogleMap from '~/components/shared/configurable/map/CGoogleMap.vue'
import CMapLocationInput from '~/components/shared/configurable/location/CMapLocationInput.vue'
import { FullLocation } from '~/models/google'
import { useClassifiedForm } from '~/compositions/form'
import { useI18n } from '~/compositions/i18n'
import { Geolocation } from '~/models/common/types'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_FORM_NS,
  FormState
} from '~/store/modules/shared/classifieds/form/state'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'

export default defineComponent({
  components: {
    CMapLocationInput,
    CGoogleMap,
    FieldError,
    CGoogleAutocompleteInput
  },
  props: formFieldProps,
  setup(props) {
    const { name, specs } = toRefs(props)
    const geolocation = ref<Geolocation | null>(null)
    const address = ref('')
    const postcode = ref<string | null>('')
    const locationInputRef = ref(null)

    function onValue(v: Ref<any>) {
      if (!v.value) {
        return
      }
      geolocation.value = v.value.geolocation
      address.value = v.value.address
      postcode.value = v.value.postcode
    }
    const { error, valueChanged } = useClassifiedForm(props, { onValue })
    const { state, dispatch } = useNamespacedStore<FormState>(
      CLASSIFIED_FORM_NS
    )
    const { t } = useI18n()
    const user = computed(() => state.fieldValues.user)
    const hasStoreChanged = ref(false)

    function onLocationInputChange(data: FullLocation) {
      geolocation.value = data.geolocation
      address.value = data.address
      postcode.value = data.postcode

      valueChanged(name.value, {
        geolocation: data.geolocation,
        address: data.address,
        postcode: data.postcode
      })
    }

    function afterInputChange() {
      if (locationInputRef.value) {
        locationInputRef.value.setZoom(geolocation.value ? 12 : 5)
      }
    }

    const internalError = computed(() => {
      if (!error.value) {
        return null
      } else if (
        typeof error.value === 'object' &&
        (error.value as any).geolocation
      ) {
        return (error.value as any).geolocation
      } else if (typeof error.value === 'object') {
        return t('location not valid').toString()
      }
      return error.value
    })

    watch(user, () => {
      hasStoreChanged.value = true
    })

    watch(specs, newSpecs => {
      if (newSpecs.address && hasStoreChanged.value) {
        dispatch('changeFieldValue', {
          name: name.value,
          value: {
            geolocation: newSpecs?.user_geolocation,
            address: newSpecs?.address,
            postcode: newSpecs?.postcode
          }
        })
        hasStoreChanged.value = false
      }
    })

    return {
      geolocation,
      address,
      postcode,
      onLocationInputChange,
      locationInputRef,
      internalError,
      afterInputChange
    }
  }
})
